import React from "react";
import Loader from "./Loader";
import { formatDate, formatNumberWithoutFraction } from "../utility";
import { useTranslation } from "react-i18next";
import RouteView from "../assets/route-view.svg";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../routes/constants";

type Leader = {
  id: number;
      position_number: number;
      emp_id: string;
      name_eng: string;
      name_arb: string;
      cartons_sold: number;
      cartons_target: number;
      percentage_sold: number;
      sales_office_id: string;
      sales_office_name: string;
};

type LeaderTableProps = {
  leaderData: any;
  loader: boolean;
  getIndex: (leaderData: any, index: number) => number;
  setEmployee: (empId: string[]) => void;
  selected?: any,
  startDate?: any,
};

const SupervisorLeaderTable: React.FC<LeaderTableProps> = ({
  leaderData,
  loader,
  getIndex,
  setEmployee,
  selected,
  startDate
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleEmployeeClick = (empId: any) => {
    setEmployee([empId]);
  };

  const formattedToday = formatDate(startDate)

  const handleRouteClick = (id: string | number) => {
    navigate(URL_MAPPING.SUPERVISORMAP, {
      state: { id, selectDate: formattedToday },
    });
  };
  return (
    <>
      <table className="min-w-full table-auto text-left">
        <thead className="sticky top-0 w-full">
          <tr className="bg-[#DEDEDE] text-white">
            <th className="px-2  text-center text-black py-2 text-13 font-bold">#</th>
            <th className="px-4 text-black py-2 text-13 font-bold">
              {t("leaderboard.Supervisor Name/ID")}
            </th>
            <th className="px-4 text-black py-2 text-13 font-bold max-w-[130px]">
              {t("leaderboard.Actual/ Target")}
            </th>
            <th className="px-4 text-black py-2 text-13 font-bold">
              {t("leaderboard.Salesofficename")}
            </th>
            <th className="px-4 text-black py-2 text-13 font-bold">%</th>
            <th className="px-4 text-black py-2 text-13 font-bold"> {t("leaderboard.route")}</th>
          </tr>
        </thead>
        <tbody>
          {leaderData?.map((leader: Leader, index: number) => (
            <tr
              key={index}
              className={`${selected[0] == leader.emp_id ? 'bg-[#EBEBEB]' : 'bg-white'}  border-b cursor-pointer`}
              onClick={() => handleEmployeeClick(leader.emp_id)}
            >
              <td className="px-2 text-center py-2 text-gray-700 text-13 font-bold">
                {leader.position_number}
              </td>
              <td className="px-2 py-2 text-gray-700 text-13 font-bold max-w-[180px]">
                <div className="flex flex-col">
                  <p className="font-bold">
                    {i18n.language === "ar" ? leader.name_arb : leader.name_eng}
                  </p>
                  <p className="text-[10px] font-medium">{leader.emp_id}</p>
                </div>
              </td>
              <td className="px-4 py-2 text-gray-700 text-13 font-bold">
                {formatNumberWithoutFraction(leader?.cartons_sold)}/
                {formatNumberWithoutFraction(Math.max(Number(leader.cartons_target), 1))}
              </td>
              <td className="px-4 py-2 text-gray-700 text-13 font-bold">
                {leader.sales_office_name}
              </td>
              <td className="px-4 py-2 text-gray-700 text-13 font-bold">
                {Math.max(Number(leader.percentage_sold), 1)}
              </td>
              <td className="px-4 py-2 text-gray-700 text-13 font-bold">
                <img src={RouteView} onClick={(event) => {
                  event.stopPropagation();
                  handleRouteClick(leader.emp_id);
                }} alt='route' className='w-12 h-10 cursor-pointer' />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div>{loader && <Loader />}</div>
    </>
  );
};

export default SupervisorLeaderTable;